import React from "react";

const SearchButton = () => <button className="btn btn-success">Search</button>;

export default SearchButton;
